import { render, staticRenderFns } from "./sortClockList.vue?vue&type=template&id=3446c970&scoped=true&"
import script from "./sortClockList.vue?vue&type=script&lang=js&"
export * from "./sortClockList.vue?vue&type=script&lang=js&"
import style0 from "./sortClockList.vue?vue&type=style&index=0&id=3446c970&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3446c970",
  null
  
)

export default component.exports